import { z } from 'zod';

const DiscountSchema = z.object({
  code: z.string(),
  name: z.string(),
  amount: z.number(),
  amountUnits: z.enum(['percent', 'dollars']),
  start: z.string(),
  end: z.string(),
  duration: z.enum(['once', 'forever']).optional(),
  minimum: z.number().optional(),
  minimumUnits: z.enum(['copies', 'dollars']).optional(),
  productIds: z.string().array(),
  _id: z.string(),
});

export type Discount = z.infer<typeof DiscountSchema>;

// List all discounts
export const ListDiscountsResponseSchema = DiscountSchema.array();

export type ListDiscountsResponse = z.infer<typeof ListDiscountsResponseSchema>;
export type ListDiscountsRequest = void;

// Get one discount
export const GetDiscountResponseSchema = DiscountSchema;
export type GetDiscountResponse = z.infer<typeof GetDiscountResponseSchema>;
export type GetDiscountRequest = string;

// Create a discount
export const CreateDiscountResponseSchema = DiscountSchema;
export type CreateDiscountResponse = z.infer<
  typeof CreateDiscountResponseSchema
>;
export type CreateDiscountRequest = Omit<Discount, '_id'>;

// Update a discount
export const UpdateDiscountResponseSchema = DiscountSchema;
export type UpdateDiscountResponse = z.infer<
  typeof UpdateDiscountResponseSchema
>;
export type UpdateDiscountRequest = Discount;

export const DeleteDiscountResponseSchema = z.object({
  message: z.string(),
});
export type DeleteDiscountResponse = z.infer<
  typeof DeleteDiscountResponseSchema
>;
export type DeleteDiscountRequest = string;
